/* This is the EMIS Classes for secondary school components */
<template>
  <v-container>
    <div>
      <span v-html="title"></span>
    </div>
    <div>
      <table width="800px;" border="1px;" cellspacing="0px;">
        <tbody>
          <!-- Title row -->
          <tr>
            <td class="row-title">ថ្នាក់រៀន និងបន្ទប់រៀន</td>
            <td class="row-data">ថ្នាក់ទី ៧</td>
            <td class="row-data">ថ្នាក់ទី ៨</td>
            <td class="row-data">ថ្នាក់ទី ៩</td>
            <td class="row-data">ថ្នាក់ទី ១០</td>
            <td class="row-data">ថ្នាក់ទី ១១.វិ</td>
            <td class="row-data">ថ្នាក់ទី ១១.ស</td>
            <td class="row-data">ថ្នាក់ទី ១២.វិ</td>
            <td class="row-data">ថ្នាក់ទី ១២.ស</td>
            <td class="row-data">សរុប</td>
          </tr>
          <!-- 2nd row -->
          <tr>
            <td class="row-title">ចំនួនថ្នាក់រៀន</td>
            <td
              v-for="(value, col) in data[0].dt.length"
              :key="col"
              class="row-data"
            >
              <numberinput v-model="data[0].dt[col]" class="number" />
            </td>
            <td class="row-data">
              <strong>{{ row }}</strong>
            </td>
          </tr>

          <!-- 3rd row -->
          <tr>
            <td class="row-title">ចំនួនបន្ទប់រៀន</td>
            <td
              v-for="(value, col) in data[1].dt.length"
              :key="col"
              class="row-data"
            >
              <numberinput v-model="data[1].dt[col]" class="number" />
            </td>
            <td class="row-data">
              <strong>{{ row1 }}</strong>
            </td>
          </tr>

          <!-- 4th row -->
          <!--
          <tr>
            <td class="row-title">ចំនួនគ្រូបង្រៀន</td>
            <td
              v-for="(value, col) in data[2].dt.length"
              :key="col"
              class="row-data"
            >
              <numberinput v-model="data[2].dt[col]" class="number" />
            </td>
            <td class="row-data">
              <strong>{{ row2 }}</strong>
            </td>
          </tr>
          -->
          <!-- 5th row -->
          <tr>
            <td class="row-title">ចំនួនគ្រូបង្រៀនSTEM</td>
            <td
              v-for="(value, col) in data[3].dt.length"
              :key="col"
              class="row-data"
            >
              <numberinput v-model="data[3].dt[col]" class="number" />
            </td>
            <td class="row-data">
              <strong>{{ row3 }}</strong>
            </td>
          </tr>

          <tr>
            <td class="row-title">ចំនួនគ្រូបង្រៀនបានឆ្លងកាត់វគ្គ(STEM)</td>
            <td
              v-for="(value, col) in data[4].dt.length"
              :key="col"
              class="row-data"
            >
              <numberinput v-model="data[4].dt[col]" class="number" />
            </td>
            <td class="row-data">
              <strong>{{ row4 }}</strong>
            </td>
          </tr>

          <tr>
            <td class="row-title">ចំនួនគ្រូបង្រៀនមិនបានឆ្លងកាត់វគ្គ(STEM)</td>
            <td
              v-for="(value, col) in data[5].dt.length"
              :key="col"
              class="row-data"
            >
              <numberinput v-model="data[5].dt[col]" class="number" />
            </td>
            <td class="row-data">
              <strong>{{ row5 }}</strong>
            </td>
          </tr>
          
        </tbody>
      </table>
    </div>
  </v-container>
</template>

<script>
import NumberInput from "@/components/common/NumberInput.vue";
export default {
  props: ["data", "title"],
  components: {
    numberinput: NumberInput,
  },
  computed: {
    row: function () {
      let d = this.data[0].dt;
      return (
        Number(d[0]) +
        Number(d[1]) +
        Number(d[2]) +
        Number(d[3]) +
        Number(d[4]) +
        Number(d[5]) +
        Number(d[6]) +
        Number(d[7])
      );
    },
    row1: function () {
      let d = this.data[1].dt;
      return (
        Number(d[0]) +
        Number(d[1]) +
        Number(d[2]) +
        Number(d[3]) +
        Number(d[4]) +
        Number(d[5]) +
        Number(d[6]) +
        Number(d[7])
      );
    },
    /*
    row2: function () {
      let d = this.data[2].dt;
      return (
        Number(d[0]) +
        Number(d[1]) +
        Number(d[2]) +
        Number(d[3]) +
        Number(d[4]) +
        Number(d[5])
      );
    },
    */
    row3: function () {
      let d = this.data[3].dt;
      return (
        Number(d[0]) +
        Number(d[1]) +
        Number(d[2]) +
        Number(d[3]) +
        Number(d[4]) +
        Number(d[5]) +
        Number(d[6]) +
        Number(d[7])
      );
    },
    row4: function () {
      let d = this.data[4].dt;
      return (
        Number(d[0]) +
        Number(d[1]) +
        Number(d[2]) +
        Number(d[3]) +
        Number(d[4]) +
        Number(d[5]) +
        Number(d[6]) +
        Number(d[7])
      );
    },
    row5: function () {
      let d = this.data[5].dt;
      return (
        Number(d[0]) +
        Number(d[1]) +
        Number(d[2]) +
        Number(d[3]) +
        Number(d[4]) +
        Number(d[5]) +
        Number(d[6]) +
        Number(d[7])
      );
    },
  },
};
</script>

<style scoped>
.number {
  width: 50px;
  text-align: center;
}
.row-data {
  width: 90px;
  height: 25px;
  text-align: center;
  vertical-align: middle;
}
.row-title {
  width: 170px;
  height: 25px;
  text-align: left;
  vertical-align: middle;
}
</style>